import { IUserRef } from "./userData.model";

export enum RepetitiveTaskType {
  weekly = "weekly",
  monthly = "monthly",
  yearly = "yearly",
}

export enum RepetitiveTaskDays {
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
  sunday = "sunday",
}

export interface IRepetitiveTaskData {
  type: RepetitiveTaskType;
  data: {
    days?: RepetitiveTaskDays[];
    date?: string;
    noOfDays?: number;
  };
}

export interface ITaskAttachment {
  _id?: string;
  url: string;
  name: string;
  isCrossVisible: boolean;
}

export interface IComment {
  _id?: string;
  mentions: string[];
  comment: string;
  createdAt: Date;
  attachedBy: IUserRef;
}

export interface IDuplicate {
  duplicateOfTaskId: string;
  isDuplicate: boolean;
  remark: string;
}

export interface ITaskManagement {
  _id?: string;
  taskName: string;
  assignee: string;
  followers: string[];
  type: string;
  description: string;
  priority: string;
  status: string;
  approxTime?: string;
  startDate: Date | null;
  endDate: Date | null;
  requestedEndDate?: Date | null;
  duplicate?: IDuplicate;
  author?: string;
  attachments?: ITaskAttachment[];
  comments?: IComment[];
  typeOfRepetition?: IRepetitiveTaskData;
  repetitiveTaskId?: string;
  completionDate?: Date | null;
  isCompleted?: boolean;
}

export interface IChange {
  field: string;
  oldValue: any;
  newValue: any;
  reason?: string;
}

export interface ITaskManagerRef {
  _id: string;
  taskName: string;
}

export interface ITaskManagementLog {
  _id: string;
  taskId: ITaskManagerRef;
  changes: IChange[];
  createdAt: Date;
  updatedBy: {
    _id: string;
    username: string;
  };
}

export interface IRepetitiveTaskManager {
  _id?: string;
  taskName: string;
  assignee: string;
  author: string;
  followers: string[];
  type: string;
  description: string;
  priority: string;
  status: string;
  approxTime?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  attachments?: ITaskAttachment[];
  addedDates?: Map<string, string>;
  typeOfRepetition?: IRepetitiveTaskData;
  isCompleted: boolean;
}
